import { z } from "zod";

const createCustomerSchema = z.object({
  name: z.string().trim().min(1, {
    message: "Name is required.",
  }),
});

export default createCustomerSchema;
